import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ViewPreferenceService {
  private static readonly storageKeyPrefix = 'birco.viewPreference';

  getIsListView(viewKey: string, fallback = true): boolean {
    try {
      const storedView = localStorage.getItem(this.getStorageKey(viewKey));

      if (storedView === 'list') {
        return true;
      }

      if (storedView === 'tiles') {
        return false;
      }
    } catch {
      // Ignore storage access issues and fall back to the default view.
    }

    return fallback;
  }

  setIsListView(viewKey: string, isListView: boolean): void {
    try {
      localStorage.setItem(this.getStorageKey(viewKey), isListView ? 'list' : 'tiles');
    } catch {
      // Ignore storage access issues to avoid breaking the UI interaction.
    }
  }

  private getStorageKey(viewKey: string): string {
    return `${ViewPreferenceService.storageKeyPrefix}.${viewKey}`;
  }
}
